import BatchCloseModal from "./BatchCloseModal";

export default BatchCloseModal